import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {LocationPathNodeModel} from '@/sdk/models';
import {AdminDataFieldService} from '@/views/shared/services';
import {Component, Prop} from 'vue-property-decorator';

@Component({
    name: 'IntrinsicSafetyParametersComponent',
    components: {},
})
export default class IntrinsicSafetyParametersComponent extends VueWrapper {
    public $refs!: {};

    @Prop({required: true}) public node: LocationPathNodeModel;

    public adminDataFieldService = new AdminDataFieldService();

    public mounted() {}
}
